import { InvoiceConfigActions } from './actionTypes';
import {
    getInvoiceConfig,
    updateInvoiceConfigGeneralSettings,
    updateInvoiceConfigInvoiceTemplate,
    updateInvoiceConfigEmailTemplate,
} from './client';
import {
    UpdateInvoiceConfigGeneralSettingsPayload,
    UpdateInvoiceConfigInvoiceTemplatePayload,
    UpdateInvoiceConfigEmailTempaltePayload,
} from './types';

export const doGetInvoicesConfig: Function = () => async (dispatch: Function) => {
    dispatch({ type: InvoiceConfigActions.GET_INVOICE_CONFIG_REQUEST });
    try {
        const config = await getInvoiceConfig();

        dispatch({
            type: InvoiceConfigActions.GET_INVOICE_CONFIG_SUCCESS,
            payload: config,
        });

        return config;
    } catch (e: any) {
        dispatch({ type: InvoiceConfigActions.GET_INVOICE_CONFIG_ERROR, error: e?.response?.data });
        throw e;
    }
};

export const doUpdateInvoiceConfigGeneralSettings: Function =
    (payload: UpdateInvoiceConfigGeneralSettingsPayload) => async (dispatch: Function) => {
        dispatch({ type: InvoiceConfigActions.UPDATE_INVOICE_CONFIG_REQUEST });
        try {
            const updated = await updateInvoiceConfigGeneralSettings(payload);
            dispatch({ type: InvoiceConfigActions.UPDATE_INVOICE_CONFIG_SUCCESS, payload: updated });
            return updated;
        } catch (e: any) {
            dispatch({ type: InvoiceConfigActions.UPDATE_INVOICE_CONFIG_ERROR, error: e?.response?.data });
            throw e;
        }
    };

export const doUpdateInvoiceConfigInvoiceTemplate: Function =
    (payload: UpdateInvoiceConfigInvoiceTemplatePayload) => async (dispatch: Function) => {
        dispatch({ type: InvoiceConfigActions.UPDATE_INVOICE_CONFIG_REQUEST });
        try {
            const updated = await updateInvoiceConfigInvoiceTemplate(payload);
            dispatch({ type: InvoiceConfigActions.UPDATE_INVOICE_CONFIG_SUCCESS, payload: updated });
            return updated;
        } catch (e: any) {
            dispatch({ type: InvoiceConfigActions.UPDATE_INVOICE_CONFIG_ERROR, error: e?.response?.data });
            throw e;
        }
    };

export const doUpdateInvoiceConfigEmailTemplate: Function =
    (payload: UpdateInvoiceConfigEmailTempaltePayload) => async (dispatch: Function) => {
        dispatch({ type: InvoiceConfigActions.UPDATE_INVOICE_CONFIG_REQUEST });
        try {
            const updated = await updateInvoiceConfigEmailTemplate(payload);
            dispatch({ type: InvoiceConfigActions.UPDATE_INVOICE_CONFIG_SUCCESS, payload: updated });
            return updated;
        } catch (e: any) {
            dispatch({ type: InvoiceConfigActions.UPDATE_INVOICE_CONFIG_ERROR, error: e?.response?.data });
            throw e;
        }
    };
